import { useState } from "react";

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog/alert-dialog";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select/select";
import { Button } from "@/components/ui/button/button";

import { useMYPicker } from "./use-my-picker";
import { cn } from "@/lib/utils";
import { CalendarIcon } from "lucide-react";

export const MonthYearPicker = () => {
  const { my, setMY } = useMYPicker();

  const [open, setOpen] = useState(false);

  const [selectedYear, setSelectedYear] = useState<number>(
    new Date().getFullYear()
  );
  const [selectedMonth, setSelectedMonth] = useState<number>(
    new Date().getMonth()
  );

  const handleSave = () => {
    setMY({
      month: selectedMonth,
      year: selectedYear,
    });
    setOpen(false);
  };

  const months = [
    { label: "January", value: 0 },
    { label: "February", value: 1 },
    { label: "March", value: 2 },
    { label: "April", value: 3 },
    { label: "May", value: 4 },
    { label: "June", value: 5 },
    { label: "July", value: 6 },
    { label: "August", value: 7 },
    { label: "September", value: 8 },
    { label: "October", value: 9 },
    { label: "November", value: 10 },
    { label: "December", value: 11 },
  ];

  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  const getLast20Years = () => {
    const currentYear = getCurrentYear();
    const years = [];
    for (let i = 0; i < 20; i++) {
      years.push(currentYear - i);
    }
    return years;
  };

  const years = getLast20Years();

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger>
        <Button
          id="date"
          variant="outline"
          className={cn(
            "w-[260px] justify-start text-left font-normal",
            !my && "text-muted-foreground"
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {my.month && my.year ? (
            <div>
              {months.find((m) => m.value === my.month)?.label} - {my.year}
            </div>
          ) : (
            <div>Pick Month</div>
          )}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Pick Month and Year</AlertDialogTitle>
        </AlertDialogHeader>
        <div className="grid gap-4 py-4">
          <div>
            <Select
              value={String(selectedMonth)}
              onValueChange={(value) => {
                setSelectedMonth(Number(value));
              }}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Select a month" />
              </SelectTrigger>
              <SelectContent className="max-h-[300px]">
                <SelectGroup>
                  {months.map((month) => {
                    return (
                      <SelectItem key={month.value} value={String(month.value)}>
                        {month.label}
                      </SelectItem>
                    );
                  })}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>

          <div>
            <Select
              value={String(selectedYear)}
              onValueChange={(value) => {
                setSelectedYear(Number(value));
              }}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Select a year" />
              </SelectTrigger>
              <SelectContent className="max-h-[300px]">
                <SelectGroup>
                  {years.map((year) => {
                    return (
                      <SelectItem key={year} value={String(year)}>
                        {year}
                      </SelectItem>
                    );
                  })}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel
            onMouseDown={() => {
              setMY(my);
            }}
          >
            Cancel
          </AlertDialogCancel>
          <Button
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();

              handleSave();
            }}
          >
            Save
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
